import { FaWhatsapp, FaInstagram, FaLinkedin, FaFacebook } from "react-icons/fa";
import '../App.css';
import { Link } from "react-router-dom";


const Footer = (props) =>{
    return(
        <div className="container-fluid bg-black py-5 px-xl-5">
           <div className="row p-xl-5">
                <div className="col-12 px-xl-5">
                    <div className="row px-xl-5">
                       
                        <div className="col-12 col-md-6 col-lg-4 ps-lg-5 order-3 order-md-1">
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item border-0 bg-black"><h5 class="text-white">{props.info.head2}</h5></li>
                                <li className="list-group-item border-0 bg-black"></li>
                                <li className="list-group-item border-0 text-light bg-black">{props.info.li11}</li>
                                
                            </ul>

                            <ul className="list-group list-group-flush">
                                <li className="list-group-item border-0 bg-black"><h5 class="text-white">{props.info.head99}</h5></li>
                                <li className="list-group-item border-0 bg-black"></li>
                                <li className="list-group-item border-0 text-light bg-black">{props.info.li99}</li>
                                
                            </ul>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 ps-lg-5 order-3 order-md-1">
                            <ul className="list-group list-group-flush">
                                <li className="list-group-item border-0 bg-black"><h5 class="text-white">{props.info.head3}</h5></li>
                                
                                <li className="list-group-item border-0 bg-black text-white">
                                {/* <Link className="text-decoration-none text-light" to="#">
                                 {/* </Link> */}
                                 {props.info.li21}
                                </li>
                                
                                <li className="list-group-item border-0 bg-black">
                            <Link className="text-decoration-none text-light" to="/aboutus">
                                {props.info.li71}
                            </Link>
                        </li>

                        <li className="list-group-item border-0 bg-black">
                            <Link className="text-decoration-none text-light" to="/hows">
                                {props.info.li72}
                            </Link>
                        </li>

                        <li className="list-group-item border-0 bg-black">
                            <Link className="text-decoration-none text-light" to="/pricing">
                                {props.info.li22}
                            </Link>
                        </li>

                        <li className="list-group-item border-0 bg-black">
                        <Link className="text-decoration-none text-light" to="/case-studies">
                            {props.info.li23}
                        </Link>
                    </li>
                                 
                    <li className="list-group-item border-0 bg-black">
                    <Link className="text-decoration-none text-light" to="/reviews">
                        {props.info.li24}
                    </Link>
                </li>

                <li className="list-group-item border-0 bg-black">
                    <Link className="text-decoration-none text-light" to="/contact">
                        {props.info.li25}
                    </Link>
                </li>

                
                <li className="list-group-item border-0 bg-black">
                    <Link className="text-decoration-none text-light" to="/get-started">
                        {props.info.li70}
                    </Link>
                </li>
                            </ul>
                        </div>
                        <div className="col-12 col-md-6 col-lg-4 ps-lg-5 order-3 order-md-1">
                            <ul className="list-group list-group-flush">
                            <li className="list-group-item border-0 bg-black"><h5 class="text-white">Have a Question</h5></li>
                            <li className=" list-group-item border-0 bg-black">
                            <a href="/contact?policy=privacy" className=" text-decoration-none text-white">
                                Privacy Policy
                            </a>
                            </li>
                            <li className="list-group-item border-0 bg-black">
                            <a href="/contact?policy=terms" className="text-decoration-none text-white">
                                Terms & Conditions
                            </a>
                            </li>
                            <li className="list-group-item border-0 bg-black">
                            <a href="/contact?policy=refund" className="text-decoration-none text-white">
                                Refund Policy
                            </a>
                            </li>
                            <li className="list-group-item border-0 text-light bg-black"><i className="fas fa-phone-alt"></i> {props.info.li32}</li>
                            <li className="list-group-item border-0 text-light bg-black"><i className="fas fa-envelope pe-2 text-white"></i>{props.info.li33}</li>
                            </ul>
                        </div>
                    </div>
    
                  <div className="social-icons mb-5 mt-5">
                          <a href="https://api.whatsapp.com/send?phone=9834429482&text=Hello,%20%0A%20I%20have%20a%20question%20about%20https%3A%2F%2Fwww.fusionspherellp.com%2Findex.html" target="_blank" rel="noopener noreferrer">
                            <FaWhatsapp className="icon whatsapp" data-aos="fade-up"
                              data-aos-duration="3000"/>
                          </a>
                          <a href="https://instagram.com/" target="_blank" rel="noopener noreferrer">
                            <FaInstagram className="icon instagram" data-aos="fade-up"
                            data-aos-duration="3000"/>
                          </a>
                          <a href="https://linkedin.com/" target="_blank" rel="noopener noreferrer">
                            <FaLinkedin className="icon linkedin" data-aos="fade-up"
                              data-aos-duration="3000" />
                          </a>
                          <a href="https://facebook.com/" target="_blank" rel="noopener noreferrer">
                            <FaFacebook className="icon facebook" data-aos="fade-up"
                              data-aos-duration="3000" />
                          </a>
                        </div>

                    <div class="col-12 text-center pt-0">
                    <p class="text-light">{props.info.copy} <i className="fas fa-heart color1"></i></p>
                    </div>
                </div>
           </div>
        </div>
    );
}
export default Footer;